import { render, staticRenderFns } from "./partReturn.vue?vue&type=template&id=d79d7ff4&"
import script from "./partReturn.vue?vue&type=script&lang=js&"
export * from "./partReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports